import SearchPreview from './SearchPreview';

export default SearchPreview;
